module.exports = __webpack_public_path__ + "static/media/hero-cruceros.a5e7c887.webp";